import * as Telemetry from "./Telemetry";
import { Dictionary } from "~/Types/Common";

// this comes from https://jorgeartieda.gitbook.io/typescript-from-namespaces-to-modules/solution
// there are other things in there that may be useful

// this is the typing that the old AC references so that it doesn't get compile errors
// vite creates a .d.ts file for this, which is referenced by the old ac's tsconfig file
// we have to duplicate the function definitions in here
// the methods from the link above weren't working correctly because we create two different bundles
declare global {
    namespace telemetry {
        const identify: (parameter: IdentifyParameter) => void;
        const group: () => void;
        const page: (parameter: PageParameter) => void;
        const track: (eventName: string, emailAddress?: string, properties?: Dictionary<unknown>) => void;
        const reset: () => void;
        const getCurrentIdentifiedUserId: () => Promise<string | null | undefined>;
    }
}

type PageParameter = {
    category?: string;
    name?: string;
    path?: string;
    url?: string;
    referrer?: string;
};

type IdentifyParameter = {
    email: string;
    firstName: string;
    lastName: string;
    id: string;
};

// this adds everything to the global namespace so that the old AC can call it
window.telemetry = window.telemetry || {};
window.telemetry = {
    ...window.telemetry,
    ...Telemetry.telemetry,
};
